import { compareAsc, isValid } from 'date-fns';
import { getBannerTimeRange } from './banners.utils';

export const validationErrors = (
  values = {},
  { requireFutureEndDate = false } = {}
) => {
  let msg;
  const { timeFrom, timeTo } = getBannerTimeRange(values);

  const fromDate = new Date(`${values.dateFrom}T${timeFrom}`);
  const toDate = new Date(`${values.dateTo}T${timeTo}`);

  if (!values.title) {
    msg = 'Įveskite banerio pavadinimą';
  }

  if (values.hasDiscount && !values.discountId) {
    msg = 'Pasirinkite nuolaidą';
  }

  if (!values.hasDiscount && !values.deepLink) {
    msg = 'Pasirinkite deeplink nuorodą';
  }

  if (!values.dateFrom || !values.dateTo) {
    msg = 'Pasirinkite galiojimo laikotarpį';
  }

  if (!values.placements?.length) {
    msg = 'Pasirinkite bent vieną rodymo vietą';
  }

  if (!isValid(fromDate) || !isValid(toDate)) {
    msg = 'Blogai įvestas laikotarpis';
  }

  if (
    isValid(fromDate) &&
    isValid(toDate) &&
    compareAsc(toDate, fromDate) !== 1
  ) {
    msg = '"Laikotarpis iki" turi būti vėliau nei "Laikotarpis nuo"';
  }

  if (
    requireFutureEndDate &&
    isValid(toDate) &&
    toDate.getTime() <= Date.now()
  ) {
    msg = '"Laikotarpis iki" turi būti ateityje';
  }

  return msg;
};
